import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContex } from "../context API/UserContext";

const AddTestimonal = () => {
  const [name, setName] = useState("");
  const [imagec, setImage] = useState();
   const [userData, setUserData] = useContext(UserContex);
  const navigate = useNavigate();
  const formData = new FormData();
  
  formData.append("imagec", imagec);
  formData.append("name", name);
  console.log(imagec);
  const handlesubmit = (e) => {
    e.preventDefault();
    axios
      .post("https://back.waratechnology.com/api/portifolio/setcompany", formData)
      .then((res) => {
        console.log(res.data.msg);
        navigate("/portifolio");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (!userData.user) {
      navigate("/login");
    }
  });
  return (
    <div className="bg-gray-400  flex justify-center items-center h-screen pt-12 ">
      <div className="w-3/4 h-3/4 md:w-1/2 md:h-3/4 bg-white  border border-black-1 border-rounded rounded-2xl p-4 shadow-lg shadow-white-500/50 ">
        <div className="flex justify-center mt-2 mb-4">
          <h1 className="uppercase font-bold text-2xl">Add New Company</h1>
        </div>
        <form onSubmit={handlesubmit}>
          <div className="flex py-4">
            <label className=" font-bold mr-2">Company</label>
            <input
              placeholder="company name"
              type="text"
              className="w-full pl-2 h-12 md:h-8  border border-gray-300 rounded-2xl"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="flex py-4">
            <label className=" font-bold mr-2">logo</label>
            <input
              placeholder="company logo"
              type="file"
              className="w-full h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setImage(e.target.files[0])}
            />
          </div>

          <div className="flex justify-center mt-4">
            <button
              type=""
              className="uppercase bg-red-500 mt-4 text-white px-4 py-1 rounded rounded-fully"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTestimonal;
